<template>
  <v-container 
    v-if="!$apollo.loading"
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      v-if="!editMode"
      justify-center
      wrap
    >
      <v-flex
        v-if="moduleStaking && moduleStaking.length > 0"
        md12
      >
        <h2>{{ $t('modules.moduleStaking') }}</h2>
        <v-card>
          <v-data-table
            class="text-no-wrap" 
            :headers="headers"
            :items="moduleStaking"
            :hide-default-footer="true"
            :mobile-breakpoint="900"
            :items-per-page="200"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                v-text="header.text"
              />
            </template>
            <template v-slot:item.symbol="{ item }">
              <b>{{ item.symbol }}</b>
            </template>

            <template v-slot:item.token_contract_address="{ item }">
              {{ item.token_contract_address | truncateEthAddress }}
            </template>
            <template v-slot:item.staking_contract_address="{ item }">
              {{ item.staking_contract_address | truncateEthAddress }}
            </template>
            <template v-slot:item.price_in_usdt="{ item }">
              <v-icon
                v-if="item.price_in_usdt == 0"
                style="font-size: 16px;margin-top:-3px; margin-right:3px;"
                class="text-negative"
                v-on="on"
              >
                mdi-alert-circle
              </v-icon>
              <b>{{ item.price_in_usdt }} USDT</b>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-menu
                offset-y
                left
                bottom
              >
                <template v-slot:activator="{ on }">
                  <v-btn
                    outlined 
                    small
                    text
                    v-on="on"
                  >
                    {{ $t('globals.manageButton') }}
                  </v-btn>
                </template>
                <v-sheet dense>
                  <v-list-item
                    @click="editToken(item)"
                  >
                    <v-list-item-title>{{ $t('globals.editButton') }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="deleteToken(item.id)"
                  >
                    <v-list-item-title>{{ $t('globals.deleteButton') }}</v-list-item-title>
                  </v-list-item>
                </v-sheet>
              </v-menu>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
      <v-flex
        v-else
        md5
        xs12
        new-record
      >
        <v-row>
          <v-col cols="12">
            <v-row
              justify="center"
              align="center"
            >
              <v-col>
                <v-card
                  style="padding:50px"
                >
                  <v-icon style="font-size: 100px;margin-bottom:20px;">
                    {{ moduleData.public_config.menu.config[0].icon }}
                  </v-icon>
                  <h3>{{ $t('modules.moduleStaking') }}</h3>
                  <p>{{ $t('modules.moduleStakingDesc') }}</p>
                  <v-btn
                    class="primary mt-3"
                    @click="editMode = true"
                  >
                    {{ $t('globals.createButton') }}
                  </v-btn>
                </v-card> 
              </v-col>
            </v-row>
          </v-col>
        </v-row>    
      </v-flex>
    </v-layout>
    <edit-form
      v-if="editMode"
      :module-staking="selectedItem"
      :whitelabel-uuid="getWhiteLabel.uuid"
      :module-data="moduleData"
      @changeEditMode="changeEditMode"
    />
  </v-container>
</template>

<script>

import STAKING_QUERY from "@/graphql/queries/modules/Staking.gql";
import IconProduct from '@/components/icons/IconProduct.vue'
import EditForm from "@/views/Modules/Staking/NewOrEdit.vue";
import { mapGetters } from 'vuex'

import DELETE_STAKING_MUTATION from "@/graphql/mutations/modules/StakingDelete.gql";

export default {
  name: 'ModuleStaking',
  components: {
    EditForm
  },
  data() {
    return {
      newIcon: IconProduct,
      loading: false,
      editMode: false,
      selectedItem: null,
      headers: [
        {
          sortable: false,
          text: this.$t('modules.stakingSymbol'),
          value: 'symbol'
        },
        {
          sortable: false,
          text: this.$t('modules.tokenContract'),
          value: 'token_contract_address',
        },
        {
          sortable: false,
          text: this.$t('modules.stakingContract'),
          value: 'staking_contract_address',
        },
        {
          sortable: false,
          text: this.$t('modules.stakingNetwork'),
          value: 'network'
        },
        {
          sortable: false,
          text: this.$t('modules.stakingPrice'),
          value: 'price_in_usdt'
        },
        {
          sortable: false,
          text: '',
          value: 'actions',
        },
      ]
    }
  },
  computed: {
    ...mapGetters("whitelabel", ["getWhiteLabel"]),
    moduleData() {
      if (this.getWhiteLabel && this.getWhiteLabel.modules.length > 0) {
        return this.getWhiteLabel.modules.find(item => item.module == 'staking')
      }
      return null
    }
  },
  watch: {
    getWhiteLabel(val) {
      if (this.routeNotAllowed(val, 'staking')) {
        this.$router.push('/dashboard')
      }
      this.moduleStaking = []
      this.$apollo.queries.moduleStaking.refetch()
    }
  },
  methods: {
    editToken(item) {
      this.selectedItem = item
      this.editMode = true
    },
    deleteToken(id) {
      this.loading = true; 
      let params = {
        whitelabel_uuid: this.getWhiteLabel.uuid,
        token_id: id
      }
      this.$apollo
        .mutate({
          mutation: DELETE_STAKING_MUTATION,
          variables: params
        })
        .then(data => {
          this.$store.commit('app/setNotifier', this.$t('globals.success'));
          this.$apollo.queries.moduleStaking.refetch()
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    },
    changeEditMode(val) {
      this.editMode = val
    }
  },
  apollo: {
    moduleStaking: {
      fetchPolicy: "network-only",
      query() {
        return STAKING_QUERY;
      },
      variables() {
        return {
          whitelabel_uuid: this.getWhiteLabel.uuid
        };
      },
      skip() {
        return !this.getWhiteLabel;
      },
    }
  }
}
</script>
<style lang="scss" scoped>
 
</style>
